import { render } from "./ServicesTitle.vue?vue&type=template&id=60491bc0&scoped=true"
import script from "./ServicesTitle.vue?vue&type=script&lang=js"
export * from "./ServicesTitle.vue?vue&type=script&lang=js"

import "./ServicesTitle.vue?vue&type=style&index=0&id=60491bc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60491bc0"]])

export default __exports__